import { render, staticRenderFns } from "./FootballCover_c3.vue?vue&type=template&id=48b6c996&"
import script from "./FootballCover_c3.vue?vue&type=script&lang=js&"
export * from "./FootballCover_c3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports